// const API_IP = "http://localhost:3004";
const API_IP = "https://icaresolutions.ca:3004";
export { API_IP };
